import { type FunctionComponent } from 'react';
import { CART_LINK } from '../../../../constants/links';
import { StyledButton } from '../../../buttons';
import { Drawer } from '../../../common-components/drawer/drawer.component';
import CheckCircleIcon from '../../../svgs/untitled-ui/check-circle.svg';
import { CartDrawerRecommendations } from '../components/cart-drawer-recommendations/cart-drawer-recommendations.component';
import { CartDrawerSummaryItems } from '../components/cart-drawer-summary-items/cart-drawer-summary-items.component';
import { drawerMaxWidth } from './product-cart-drawer.css';

// TODO: EFDC-41955 - update components to use new design system

type CartDrawerNavigationProps = {
	onContinueShopping: () => void;
};

const CartDrawerNavigation: FunctionComponent<CartDrawerNavigationProps> = ({ onContinueShopping }) => (
	<section className="flex flex-column items-center items-end-ns justify-between w-100 mb6">
		<div className="flex flex-column flex-row-ns flex-nowrap-ns items-center justify-between w-100 mt3">
			<div className="w-100 mb2 mb0-ns pr1-ns">
				<StyledButton onClick={onContinueShopping} buttonStyle="SECONDARY" automationHook="continue-shopping">
					Continue Shopping
				</StyledButton>
			</div>
			<div className="w-100 pl1-ns">
				<StyledButton onClick={() => (window.location.href = CART_LINK)} buttonStyle="PRIMARY" automationHook="proceed-to-cart">
					Proceed to Cart
				</StyledButton>
			</div>
		</div>
	</section>
);

export type ProductCartDrawerProps = {
	familyId: number;
	variantId: number;
	onClose: () => void;
};

export const ProductCartDrawer: FunctionComponent<ProductCartDrawerProps> = ({ familyId, variantId, onClose }) => {
	const drawerTitle: JSX.Element = (
		<div className="flex flex-row flex-nowrap items-center justify-start theme-primary w-100">
			<CheckCircleIcon className="f2" />
			<h4 className="mv0 ml2">Added to Cart!</h4>
		</div>
	);

	return (
		<Drawer
			direction="right"
			ariaLabel="Cart Updated"
			title={drawerTitle}
			className={`${drawerMaxWidth} pa3 z-4`}
			titleClasses="mb-5 text-[2em]"
			onClose={onClose}>
			<CartDrawerSummaryItems />
			<CartDrawerNavigation onContinueShopping={onClose} />
			<CartDrawerRecommendations familyId={familyId} variantId={variantId} />
		</Drawer>
	);
};
